import StoryblokClient from 'storyblok-js-client';

export default function SbRichtext(node) {
  const Storyblok = new StoryblokClient({
    accessToken: 'MO4csJcrGTwFRhDN3Tpr5gtt',
  });

  return Storyblok.richTextResolver.render(node);
}
